<template>
    <div>
        <b-modal ref="novedades" size="xl" hide-footer no-close-on-backdrop title="📋 Reporte de novedades" class="modal-novedades">
            <template #modal-header="{ close }">
                <div class="d-flex w-100 align-items-center justify-content-between">
                    <h5 class="modal-title mb-0">
                        <b-icon icon="clipboard-data" class="me-2"></b-icon>
                        Reporte de novedades
                    </h5>
                    <button type="button" class="btn-close" @click="close()" aria-label="Close">
                        <b-icon icon="x" font-scale="1.2"></b-icon>
                    </button>
                </div>
            </template>
            
            <div class="novedades-container">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <div class="novedades-info">
                        <h6 class="text-muted mb-1">CBI: <span class="text-primary fw-bold">{{ unidad.cbi }}</span></h6>
                        <p class="text-muted small mb-0">Total de novedades: <span class="badge bg-danger">{{ novedades.length }}</span></p>
                    </div>
                    <button class="btn btn-gradient-primary" @click="updateEstadoNovedades">
                        <b-icon icon="trash" class="me-2"></b-icon>
                        Limpiar Novedades
                    </button>
                </div>
                
                <div class="table-responsive" v-if="novedades.length > 0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th><b-icon icon="hash"></b-icon> Item</th>
                                <th><b-icon icon="tools"></b-icon> Tipo de intervención</th>
                                <th><b-icon icon="building"></b-icon> Proveedor</th>
                                <th><b-icon icon="person-badge"></b-icon> Líder intervención</th>
                                <th><b-icon icon="chat-square-text"></b-icon> Observaciones</th>
                                <th><b-icon icon="calendar3"></b-icon> Fecha</th>
                                <th><b-icon icon="gear"></b-icon> Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="novedad, index in novedades" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <span class="badge bg-info text-dark">{{ novedad.tipo_intervencion }}</span>
                                </td>
                                <td>{{ novedad.proveedor }}</td>
                                <td>{{ novedad.lider_intervencion }}</td>
                                <td class="observaciones-cell">{{ novedad.observaciones }}</td>
                                <td>
                                    <span class="text-muted small">{{ novedad.fecha_ejecucion }}</span>
                                </td>
                                <td>
                                    <button 
                                        class="btn btn-danger btn-sm" 
                                        @click="eliminarNovedad(novedad)"
                                        :disabled="eliminandoNovedad"
                                        title="Eliminar novedad">
                                        <b-icon v-if="!eliminandoNovedad" icon="trash"></b-icon>
                                        <b-spinner v-else small></b-spinner>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div v-else class="empty-state">
                    <div class="text-center py-5">
                        <b-icon icon="clipboard-check" font-scale="3" class="text-success mb-3"></b-icon>
                        <h5 class="text-muted">Sin novedades registradas</h5>
                        <p class="text-muted">Este equipo no tiene novedades pendientes</p>
                    </div>
                </div>
            </div>
        </b-modal>
        <SinMenuConAlertas nombreAlerta="HISTORIAL DE OPERACIÓN" :show="true" :showSemaforo="false" :url="urlRegreso" :estaPagina="'HISTORIAL DE OPERACIÓN - CBI ' + unidad.cbi">
            <template #contenido>
                <HojaVida ref="generarHv" />
                <History ref="generarHistorial" />
                <Graficas ref="generarGraficas" />
                <HistoryOperaciones ref="generarHistorialOperaciones" />
                <div class="contenedor-info">
                    
                    <div v-if="loader">
                        <Loading />
                    </div>
                    <div  v-else>
                        <div class="row titulos-form text-sm">
                            <div class="col-2">CBI <br>{{ unidad.cbi }}</div>
                            <div class="col-3">UBICACION <br>{{ unidad.bloque.bloque_edificio }} - {{ unidad.area_especifica }}</div>
                            <div class="col-3">MARCA <br>{{ unidad.marca }} </div>
                            <div class="col-2">CAPACIDAD <br>{{ unidad.capacidad.capacidad }} BTU</div>
                            <div class="col-2">ON/OFF <br>
                                <span  v-if="loaderLecturas" ><b-spinner small label="Small Spinner" type="grow"></b-spinner></span>
                                <span v-else :class="setClassEstado(estado_equipo)" class="fw-bold fs-6">{{ estado_equipo }}</span>
                            </div>
                        </div>
                        <div class="row margen">
                            <div class="col-5">
                                <img :src="unidad.tipo.imagen2" alt="" width="350px" >
                            </div>
                            <div class="col-3">
                                <b-icon icon="snow" class="text-enerhvac"></b-icon>
                                <p>TEMPERATURA DE AIRE <br><span class="text-enerhvac">{{ lectura.temperatura_ds18b20 !== undefined && lectura.temperatura_ds18b20 !== null ? Number(lectura.temperatura_ds18b20).toFixed(2) : '' }} &deg;C</span></p>                            
                                <p>TEMPERATURA DE AMBIENTE <br><span class="text-enerhvac">{{ lectura.temperatura_ambiente }} &deg;C</span></p>
                                
                                <p>HUMEDAD RELATIVA <br><span class="text-enerhvac">{{ lectura.humedad_ambiente }} %</span></p>
                                
                            </div>
                            <div class="col-3 border-start">
                                <p>VOLTAJE DE OPERACION <br><span class="text-enerhvac">{{ lectura.voltaje_interior }} V</span></p>
                                <p>CORRIENTE DE OPERACION <br><span class="text-enerhvac">{{ lectura.corriente_interior !== undefined && lectura.corriente_interior !== null ? Number(lectura.corriente_interior).toFixed(2) : '' }} A</span></p>
                                <p>FACTOR DE POTENCIA <br><span class="text-enerhvac">{{ lectura.fp_interior }}</span></p>
                            </div>
                            <div class="col-1" v-if="requiere_mantenimiento">                                
                                <img src="images/medidor/img_1.png" width="100px" alt="" >
                            </div>
                            <div class="col-1" v-else>
                                <img src="images/medidor/img_3.png" width="100px" alt="" v-if="$store.state.numero_alertas === 0">
                                <img src="images/medidor/img_2.png" width="100px" alt="" v-if="$store.state.numero_alertas === 1">
                                <img src="images/medidor/img_1.png" width="100px" alt="" v-if="$store.state.numero_alertas >= 2">
                            </div>
                        </div>
                        <div class="row margen">
                            <div class="col-5">
                                <img :src="unidad.tipo.imagen1" alt="" width="350px">
                            </div>
                            <div class="col-3 ">
                                <a-avatar size="large" style="backgroundColor:#475564">A</a-avatar>
                                <div class="d-flex justify-content-center">
                                    <div>
                                        <p>CORRIENTE DE OPERACION <br><span class="text-enerhvac">{{ lectura.corriente_exterior !== undefined && lectura.corriente_exterior !== null ? Number(lectura.corriente_exterior).toFixed(2) : '' }} A</span></p>                                    
                                    </div>
                                    <div>
                                        <p>CORRIENTE NOMINAL <br><span class="text-enerhvac">{{ unidad.corriente_nominal }} A</span></p>
                                    </div>
                                </div>
                                <a-avatar size="large" style="backgroundColor:#475564">V</a-avatar>
                                <div class="d-flex justify-content-center">
                                    <div>
                                        <p>TENSION DE OPERACION <br><span class="text-enerhvac">{{ lectura.voltaje_exterior }} V</span></p>                                     
                                    </div>
                                    <div>
                                        <p>TENSION NOMINAL <br><span class="text-enerhvac">{{ unidad.voltaje.voltaje_nominal }} V</span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 border-start">
                                <p>FACTOR DE POTENCIA <br><span class="text-enerhvac">{{ lectura.fp_exterior }}</span></p>                           
                                <p>FRECUENCIA <br><span class="text-enerhvac">{{ lectura.frecuencia_exterior }}  HZ</span></p>                            
                                <p>ENERGIA CONSUMIDA <br>
                                    
                                    <span class="text-enerhvac">
                                        {{(energiaConsumida/1000).toFixed(2)}} kWh
                                    </span>
                                </p>                            
                            </div>
                            <div class="col-1 position-relative">
                                <div style="font-size: 3rem;" class="position-absolute bottom-0 end-0">
                                    <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret dropup 
                                               class="dropdown-actions"
                                               @show="forceDropdownPosition">
                                        <template #button-content>
                                            <b-icon icon="list"></b-icon>
                                        </template>

                                        <b-dropdown-item-button @click="verHistorialLecturas"><b-icon icon="clock-history"></b-icon> Historial de operacion</b-dropdown-item-button>
                                        <!-- <b-dropdown-item-button @click="verGraficas"><b-icon icon="bar-chart-line"></b-icon> Ver gráficas</b-dropdown-item-button> -->
                                        <b-dropdown-item-button @click="hojaVida"><b-icon icon="file-pdf"></b-icon> Hoja de vida del equipo</b-dropdown-item-button>
                                        <b-dropdown-item-button @click="agregarNovedad"><b-icon icon="plus"></b-icon> Reportar novedad</b-dropdown-item-button>
                                        <b-dropdown-item-button @click="verNovedades"><b-icon icon="bell"></b-icon> Ver novedades <b-badge variant="danger" v-if="novedades.length > 0">{{ novedades.length }}</b-badge></b-dropdown-item-button>
                                    </b-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="row margen titulos-form mb-2">
                            <div class="col-12 text-sm text-center">
                                <p>Tiempo de operación desde el ultimo mantenimiento: 
                                <span v-if="requiere_mantenimiento" class="badge badge-danger">{{ ultimo_mantenimiento }} Horas</span>
                                <span v-else>{{ ultimo_mantenimiento }} Horas</span></p>
                                
                                <br>
                                Tiempo de operación total: {{ formatearNumeroEntero(total_operacion) }} Horas                          
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #botones v-if="$store.state.numero_alertas > 0"> 
                <button class="btn btn-success text-sm mr-1" @click="filtrar"><b-icon icon="filter"></b-icon> Filtrar</button>
                <button class="btn btn-danger text-sm " @click="deleteAlertas"><b-icon icon="trash"></b-icon> Eliminar alertas</button>
            </template>
        </SinMenuConAlertas>
    </div>
</template>
<script>
    import axios from 'axios';
    import SinMenuConAlertas from '@/layouts/SinMenuConAlertas.vue';
    import Loading from '../Loader/Loading.vue';
    import HojaVida from './HojaVida.vue';
    import History from './History.vue';
    import Graficas from './Graficas.vue';
    import HistoryOperaciones from './HistoryOperaciones.vue';
    import Swal from 'sweetalert2';
    export default {
        components: {
            HojaVida, Loading, SinMenuConAlertas, History, Graficas, HistoryOperaciones
        },
        props: ['item'],
        data() {
            return {
                desconecto: false,
                eliminandoNovedad: false,
                energiaConsumida: 0,
                estado_equipo: '',
                historialOperaciones: [],
                intervalId: null,
                lectura: {},
                loader: true,
                loaderHistorialOperacion: true,
                loaderLecturas: true,
                novedades: [],                
                total_operacion: null,
                requiere_mantenimiento: false,
                ultimo_mantenimiento: null,
                unidad: {}
            }
        },
        computed: {
            urlRegreso() {
                // ✅ Construir URL de regreso con página guardada
                const prevRoute = this.$store.state.prevRoute;
                
                if (prevRoute && 
                    prevRoute.name === 'Unidades' && 
                    prevRoute.params.id === this.unidad.bloque_id &&
                    prevRoute.query && 
                    prevRoute.query.page) {
                    
                    return `/unidades/${this.unidad.bloque_id}?page=${prevRoute.query.page}`;
                }
                
                // URL por defecto si no hay información previa
                return `/unidades/${this.unidad.bloque_id}`;
            }
        },
        mounted() {
            this.getUnidad();
            this.intervalId = setInterval(this.getLectura, 50000);
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },
        methods: {
            formatearNumeroEntero(numero) {
                if (numero == null || numero === '' || numero === undefined) return numero;
                // Si es string, intentar extraer solo los números
                if (typeof numero === 'string') {
                    const soloNumeros = numero.match(/[\d,.-]+/);
                    if (soloNumeros) {
                        const numeroLimpio = parseFloat(soloNumeros[0].replace(/,/g, ''));
                        if (!isNaN(numeroLimpio)) {
                            return Math.floor(numeroLimpio).toLocaleString('es-CO');
                        }
                    }
                    return numero; // Si no se puede convertir, devolver original
                }
                // Si es número
                return Math.floor(Number(numero)).toLocaleString('es-CO');
            },
            agregarNovedad(){
                this.$router.push({name: 'CrearNovedad', params: {cbi: this.unidad.cbi}})
            },
            async consultarLecturas(){
                this.energiaConsumida = 0;        
                const response = await axios.get(`/api/lecturas-today/${this.unidad.cbi}`, {
                    headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
                });
                // console.log(response.data);
                response.data.lecturas.forEach(lectura => {
                    const energia = this.calcularEnergiaConsumida(lectura);
                    this.energiaConsumida += energia;
                });

            },
            calcularEnergiaConsumida(lectura) {
                // console.log('Calculando energia consumida para lectura:', lectura);
                if (!lectura) return 0;
                let potencia = 0;
                if (typeof lectura.tiporede_id !== 'undefined') {
                    if (lectura.tiporede_id === 1 || lectura.tiporede_id === 2) potencia = Number(lectura.potencia_exterior || 0) + Number(lectura.potencia_interior || 0);
                    else potencia = (3 * Number(lectura.potencia_exterior || 0) * 0.98 ) + Number(lectura.potencia_interior || 0);
                    const tiempoOn = Number(lectura.tiempo_on || 0); // segundos
                    return (String(lectura.estado).toUpperCase() === 'ON') ? (potencia * (tiempoOn / 3600)) : 0;
                }
                return Number(lectura.valor ?? lectura.valor_kwh ?? lectura.kwh ?? lectura.energy ?? lectura.value ?? 0) || 0;
            },
            contarAlertas(){
                const cbi = this.unidad.cbi;
                this.$store.dispatch('countAlertas', cbi);
                // console.log(this.$store.state.numero_alertas)
            },
            deleteAlertas(){
                Swal.fire({
                    title: '¿Está seguro de eliminar todas las alertas de este equipo?',
                    text: 'Esta acción no se puede deshacer.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store.dispatch('deleteAlertas', this.unidad.cbi);
                        const data = {
                            municipio: 0, sede: 0, bloque: 0, cbi: this.unidad.cbi
                        }
                        this.$store.dispatch('getAlertas', data);
                        Swal.fire('Eliminado', 'Las alertas han sido eliminadas.', 'success');
                    }
                });
            },
            filtrar(){
                this.$refs.generarHistorialOperaciones.mostrarHistorialOperaciones(this.unidad);
            },
            getLectura(){
                this.loaderLecturas = true;
                axios.get(`api/lecturas/${this.unidad.cbi}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.user.token}`
                    }
                })
                .then(res => {
                    // console.log(res.data)
                    this.lectura = Object.assign({}, res.data.lectura);
                    if(res.data.segundos_transcurridos >= 120 && this.lectura.estado === 'ON'){
                        this.desconecto = true;
                    } else {
                        this.desconecto = false;
                    }
                    this.loaderLecturas = false;
                    
                    const data = {
                        municipio: 0, sede: 0, bloque: 0, cbi: this.unidad.cbi
                    }
                    
                    this.consultarLecturas();
                    this.$store.dispatch('getAlertas', data);
                    this.getTiemposOperacion(data.cbi);
                    this.contarAlertas();

                })
                .catch(err => console.log(err))
                
            },
            getNovedades(){
                axios.get(`api/ver-novedades/${this.unidad.cbi}`, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.novedades = res.data.novedades;
                    this.getLectura();
                })
                .catch(err => console.log(err))
            },
            async getTiemposOperacion(cbi){
                const res = await axios.get(`api/tiemposdeoperacion/${cbi}`, {headers: {"Authorization": `Bearer ${this.$store.state.user.token}`}})
                console.log(res.data)
                this.total_operacion = res.data.acumulado_operacion_formato_humano;
                this.ultimo_mantenimiento = res.data.acumulado_mantenimiento_formato_humano;
                this.estado_equipo = res.data.datos.estado_equipo;
                this.requiere_mantenimiento = (res.data.datos.detallealerta_id === 7) ? true : false;
            },
            getUnidad(){
                axios.get(`/api/unidades/${this.$route.params.id}`, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                    .then(res => {
                        // console.log(res.data.unidad)
                        this.unidad = Object.assign({}, res.data.unidad)
                        this.estado_equipo = this.unidad.tiempo.estado_equipo;
                        this.loader = false;
                        this.getNovedades();
                    })
                    .catch(err => console.log(err))
            },
            hojaVida(){
                this.$refs.generarHv.showModal(this.unidad.id);
            },
            updateEstadoNovedades(){
                axios.get(`api/actualizar-estado-novedades/${this.unidad.cbi}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.user.token}`
                    }
                })
                    .then(res => {
                       location.reload();
                    })
                    .catch(err => console.log(err))
            },
            hojaVida(){
                this.$refs.generarHv.showModal(this.unidad);
            },
            setClassEstado(estado){
                if(estado === 'Desconectado'){
                    return 'text-black';
                }
                return estado === 'ON' ? 'text-success' : 'text-danger';
            },
            verGraficas(){
                this.$refs.generarGraficas.show(this.unidad);
            },
            verHistorialLecturas(){
                this.$refs.generarHistorial.mostrarHistorialLecturas(this.unidad);
            },
            verNovedades(){
                this.$refs['novedades'].show()
            },
            
            async eliminarNovedad(novedad) {
                if (this.eliminandoNovedad) return;
                
                let textoAdvertencia = '';
                let tituloAdvertencia = '¿Eliminar novedad?';
                
                // Verificar si es Mantenimiento Preventivo
                if (novedad.tipo_intervencion === 'Mantenimiento Preventivo') {
                    textoAdvertencia = `Se eliminará la novedad de "${novedad.tipo_intervencion}".<br><br><strong style="color: #d69e2e;">ADVERTENCIA:</strong><br>Esta acción no restablecerá el tiempo del último mantenimiento, este permanecerá en 0.`;
                } else {
                    textoAdvertencia = `Se eliminará la novedad de "${novedad.tipo_intervencion}".`;
                }
                
                const confirmResult = await Swal.fire({
                    title: tituloAdvertencia,
                    html: textoAdvertencia,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar',
                    reverseButtons: true
                });
                
                if (!confirmResult.isConfirmed) return;
                
                this.eliminandoNovedad = true;
                
                try {
                    const response = await axios.delete(`/api/novedades/${novedad.id}`, {
                        headers: {
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        }
                    });
                    
                    if (response.data.success || response.status === 200) {
                        // Remover la novedad del array local
                        const index = this.novedades.findIndex(n => n.id === novedad.id);
                        if (index > -1) {
                            this.novedades.splice(index, 1);
                        }
                        
                        Swal.fire({
                            title: 'Éxito',
                            text: 'La novedad ha sido eliminada correctamente.',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        
                        // Si era Mantenimiento Preventivo, mostrar recordatorio adicional
                        if (novedad.tipo_intervencion === 'Mantenimiento Preventivo') {
                            setTimeout(() => {
                                Swal.fire({
                                    title: 'Recordatorio',
                                    text: 'El tiempo del último mantenimiento no fue restablecido y permanece en 0.',
                                    icon: 'info',
                                    timer: 3000,
                                    showConfirmButton: false
                                });
                            }, 2500);
                        }
                        
                    } else {
                        throw new Error('Respuesta inesperada del servidor');
                    }
                    
                } catch (error) {
                    console.error('Error eliminando novedad:', error);
                    
                    let mensajeError = 'Ocurrió un error al eliminar la novedad.';
                    
                    if (error.response) {
                        if (error.response.status === 404) {
                            mensajeError = 'La novedad no fue encontrada o ya fue eliminada.';
                        } else if (error.response.status === 403) {
                            mensajeError = 'No tienes permisos para eliminar esta novedad.';
                        } else if (error.response.data && error.response.data.message) {
                            mensajeError = error.response.data.message;
                        }
                    }
                    
                    Swal.fire({
                        title: 'Error',
                        text: mensajeError,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                } finally {
                    this.eliminandoNovedad = false;
                }
            },
            forceDropdownPosition() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        const dropdownToggle = this.$el.querySelector('.dropdown-actions .dropdown-toggle');
                        const dropdownMenu = this.$el.querySelector('.dropdown-actions .dropdown-menu');
                        
                        if (dropdownToggle && dropdownMenu) {
                            // Obtener posición del botón en la ventana
                            const buttonRect = dropdownToggle.getBoundingClientRect();
                            
                            // Calcular posición del menú cerca del botón
                            const menuTop = buttonRect.top - dropdownMenu.offsetHeight - 8; // 8px de separación
                            const menuLeft = buttonRect.left - (dropdownMenu.offsetWidth * 0.7); // 70% hacia la izquierda
                            
                            // Asegurar que no salga de la pantalla
                            const adjustedLeft = Math.max(10, Math.min(menuLeft, window.innerWidth - dropdownMenu.offsetWidth - 10));
                            
                            // Aplicar posición
                            dropdownMenu.style.position = 'fixed';
                            dropdownMenu.style.top = `${Math.max(10, menuTop)}px`;
                            dropdownMenu.style.left = `${adjustedLeft}px`;
                            dropdownMenu.style.zIndex = '9999';
                            dropdownMenu.style.visibility = 'visible';
                            dropdownMenu.style.opacity = '1';
                            dropdownMenu.style.transform = 'none'; // Remover transform CSS
                        }
                    }, 10);
                });
            }
        },
    }
</script>
<style scoped>
    .btn-link{
        color: #475564 !important;
    }
    .margen{
        margin-top: 30px !important;
    }

    /* === OPTIMIZACIÓN CONSERVADORA DEL ANCHO === */
    .contenedor-info {
        width: 100% !important;
        max-width: none !important;
        padding: 1rem 1rem !important;  /* Reducir padding lateral inicial */
        margin: 0 !important;
        box-sizing: border-box !important;
    }

    /* Optimizar las filas para usar mejor el ancho disponible */
    .contenedor-info .row {
        margin-left: 0 !important;
        margin-right: 0 !important;
        width: 100% !important;
    }

    /* Ajustar columnas para mejor distribución del espacio */
    .contenedor-info .row.titulos-form .col-2,
    .contenedor-info .row.titulos-form .col-3 {
        padding: 0.5rem 0.75rem !important;
    }

    /* Para las filas con contenido, optimizar el espacio */
    .contenedor-info .row.margen .col-5 {
        padding: 0.5rem 1rem !important;
    }

    .contenedor-info .row.margen .col-3 {
        padding: 0.5rem 1rem !important;
    }

    .contenedor-info .row.margen .col-1 {
        padding: 0.5rem !important;
    }

    /* === ESCALAMIENTO PROGRESIVO PARA PANTALLAS GRANDES === */
    @media (min-width: 1200px) {
        .contenedor-info {
            padding: 1rem 2rem !important;  /* Incrementar padding gradualmente */
        }
        
        /* Permitir imágenes ligeramente más grandes */
        .contenedor-info .col-5 img {
            max-width: 380px !important;  /* Incremento moderado */
        }
        
        /* Mejorar tipografía */
        .contenedor-info p {
            font-size: 0.95rem !important;
            line-height: 1.4 !important;
        }
        
        .contenedor-info .text-enerhvac {
            font-size: 1.1rem !important;
            font-weight: 600 !important;
        }
    }

    @media (min-width: 1400px) {
        .contenedor-info {
            padding: 1rem 4rem !important;  /* Mayor padding en pantallas XL */
        }
        
        .contenedor-info .col-5 img {
            max-width: 420px !important;  /* Imágenes más grandes en XL */
        }
        
        .contenedor-info .row.margen .col-5,
        .contenedor-info .row.margen .col-3 {
            padding: 0.75rem 1.5rem !important;  /* Más espacio entre columnas */
        }

        /* Tipografía optimizada para pantallas grandes */
        .contenedor-info p {
            font-size: 1rem !important;
        }
        
        .contenedor-info .text-enerhvac {
            font-size: 1.25rem !important;
        }
    }

    @media (min-width: 1600px) {
        .contenedor-info {
            padding: 1rem 6rem !important;  /* Máximo padding para pantallas XXL */
        }
        
        .contenedor-info .col-5 img {
            max-width: 480px !important;  /* Imágenes grandes en XXL */
        }

        .contenedor-info .row.margen .col-5,
        .contenedor-info .row.margen .col-3 {
            padding: 1rem 2rem !important;  /* Espacio generoso */
        }

        /* Tipografía grande para pantallas XXL */
        .contenedor-info p {
            font-size: 1.1rem !important;
            line-height: 1.5 !important;
        }
        
        .contenedor-info .text-enerhvac {
            font-size: 1.4rem !important;
            font-weight: 700 !important;
        }
    }

    /* === ESTILOS PARA MODAL NOVEDADES === */
    .modal-novedades :deep(.modal-header) {
        background: linear-gradient(135deg, #4a5568, #2d3748) !important;
        border: none !important;
        border-radius: 12px 12px 0 0 !important;
        padding: 1.5rem 2rem !important;
    }

    .modal-novedades :deep(.modal-title) {
        color: white !important;
        font-size: 1.25rem !important;
        font-weight: 600 !important;
        display: flex !important;
        align-items: center !important;
        margin: 0 !important;
    }
    
    /* SOLUCIÓN: Anular clases Bootstrap que afectan el dropdown */
.col-1.position-relative {
    overflow: visible !important;
}

.dropdown-actions :deep(.dropdown-menu) {
    position: fixed !important;
    z-index: 9999 !important;
    min-width: 220px !important;
}

/* Estilos básicos del componente */
    .contenedor-info > div:not(.text-center) {
        flex: 1 !important;
        display: flex !important;
        flex-direction: column !important;
        min-height: 0 !important;
        overflow: visible !important;  /* Permitir que el dropdown sea visible */
        position: relative !important;
    }
    
    /* Asegurar que las rows no se desborden */
    .contenedor-info .row {
        margin: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        flex-shrink: 0 !important;
        overflow: visible !important;  /* Permitir dropdown */
        position: relative !important;
    }
    
    /* Primera row (header) */
    .contenedor-info .row.titulos-form {
        flex-shrink: 0 !important;
        margin-bottom: 0.25rem !important;  /* Reducido de 0.5rem a 0.25rem */
        padding: 0.25rem !important;        /* Reducido de 0.5rem a 0.25rem */
    }
    
    /* Header más compacto */
    .row.titulos-form > div {
        padding: 0.15rem !important;  /* Padding muy reducido */
        font-size: 0.85rem !important;  /* Texto más pequeño */
        line-height: 1.2 !important;    /* Interlineado compacto */
    }
    
    /* Rows con margen (contenido principal) - NO incluir el footer */
    .contenedor-info .row.margen:not(.titulos-form) {
        flex: 1 !important;
        min-height: 0 !important;
        margin-bottom: 0.25rem !important;  /* Reducido de 0.5rem a 0.25rem */
        margin-top: 0 !important;
        display: flex !important;
        align-items: center !important;
    }
    
    /* Controlar el ancho de las columnas para evitar desbordamiento */
    .contenedor-info .row > [class*="col-"] {
        padding-left: 0.25rem !important;  /* Reducido de 0.5rem a 0.25rem */
        padding-right: 0.25rem !important; /* Reducido de 0.5rem a 0.25rem */
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        min-width: 0 !important;
    }
    
    /* Forzar que la columna del dropdown se expanda correctamente */
    .contenedor-info .row > .col-1.position-relative {
        overflow: visible !important;
        z-index: 1002 !important;
        position: relative !important;
    }
    
    /* Estilos específicos para el dropdown de acciones - Simplificado */
    
    /* Forzar visibilidad del dropdown en todos los ancestros */
    .main-content {
        overflow: visible !important;
    }
    
    .main-content > :last-child {
        overflow: visible !important;
    }
    
    .main-content > :last-child > * {
        overflow: visible !important;
    }
    
    /* Override adicional para layout SinMenuConAlertas */
    :deep(.sin-menu-con-alertas),
    :deep(.sin-menu),
    :deep(.layout-container),
    :deep(.main-container) {
        overflow: visible !important;
    }
    
    /* Asegurar que el contenedor padre permita el dropdown */
    .contenedor-info {
        overflow: visible !important;
        position: relative !important;
    }
    
    /* Mejorar z-index para pantallas grandes */
    @media (min-width: 992px) {
        .dropdown-actions :deep(.dropdown-menu) {
            z-index: 10000 !important;
        }
        
        .position-absolute.bottom-0.end-0 {
            z-index: 1050 !important;
        }
    }
    
    /* SOLUCIÓN FINAL PARA DROPDOWN - Contrarrestar clases Bootstrap externas */
    .contenedor-info .row .col-1.position-relative .dropdown-actions {
        width: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        flex: none !important;
    }
    
    /* Anular interferencias de .position-absolute.bottom-0.end-0 */
    .contenedor-info .position-absolute.bottom-0.end-0 .dropdown-actions {
        position: static !important;
        transform: none !important;
    }
    
    /* Posicionamiento principal del menú dropdown */
    .dropdown-actions :deep(.dropdown-menu),
    .dropdown-actions :deep(.dropdown-menu-right),
    .dropdown-actions :deep(.dropdown-menu-left),
    .dropdown-actions :deep(.dropup .dropdown-menu),
    .dropdown-actions :deep(.show.dropdown-menu),
    .dropdown-actions :deep(.b-dropdown-menu),
    .dropdown-actions.show :deep(.dropdown-menu),
    .dropdown-actions.dropup :deep(.dropdown-menu) {
        position: fixed !important;  /* Fixed para evitar contenedores padre */
        bottom: auto !important;
        top: auto !important;
        right: auto !important;
        left: auto !important;
        transform: translate(-70%, -100%) !important;  /* Posicionamiento relativo al botón */
        margin: 0 !important;
        min-width: 220px !important;
        max-width: 280px !important;
        z-index: 9999 !important;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2) !important;
        border: 1px solid #dee2e6 !important;
        border-radius: 8px !important;
        padding: 0.5rem 0 !important;
        background-color: white !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
    }
    
    /* Responsive para móviles - JavaScript manejará el posicionamiento */
    @media (max-width: 768px) {
        .dropdown-actions :deep(.dropdown-menu) {
            min-width: 200px !important;
            max-width: 250px !important;
            font-size: 0.85rem !important;
        }
    }
    
    @media (max-width: 480px) {
        .dropdown-actions :deep(.dropdown-menu) {
            min-width: 180px !important;
            max-width: 220px !important;
            font-size: 0.8rem !important;
        }
    }
    
    /* 2. Imágenes responsivas para evitar desbordamiento */
    .contenedor-info img {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
    }
    
    /* Imagen del medidor - contenedor centrado */
    .col-1 {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding: 0.25rem !important;  /* Reducido de 0.5rem a 0.25rem */
        overflow: hidden !important;
    }
    
    /* Permitir overflow para la columna del dropdown */
    .col-1.position-relative {
        overflow: visible !important;
    }
    
    .col-1 img {
        width: 100px !important;  /* Reducido de 120px a 100px */
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
    }
    
    /* Imágenes de equipos - hacerlas más compactas */
    .col-5 {
        padding: 0.25rem !important;  /* Reducir padding */
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }
    
    .col-5 img {
        width: 100% !important;
        max-width: 280px !important;  /* Reducido de 300px a 280px */
        height: auto !important;
    }
    
    /* 3. Elemento inferior (footer) compacto */
    .row.margen.titulos-form.mb-2 {
        flex: none !important;           /* NO expandir */
        flex-shrink: 0 !important;
        margin: 0 !important;
        margin-top: 0.5rem !important;   /* Margin fijo pequeño en lugar de auto */
        padding: 0.75rem 1rem !important; /* Padding horizontal más generoso */
        background-color: #4a5568 !important;
        color: white !important;
        border-radius: 8px !important;
        max-width: 100% !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
        height: auto !important;
        min-height: 60px !important;     /* Altura mínima fija y pequeña */
        max-height: 80px !important;     /* Altura máxima para evitar expansión */
        display: flex !important;
        align-items: center !important;  /* Centrar contenido verticalmente */
    }
    
    /* Mejorar el espaciado y visibilidad del footer */
    .row.margen.titulos-form.mb-2 .col-12 {
        padding: 0 !important;
        text-align: center !important;
        font-size: 0.9rem !important;     /* Texto legible */
        line-height: 1.4 !important;      /* Interlineado cómodo */
        margin: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        height: 100% !important;
    }
    
    /* Controlar el dropdown que puede causar overflow */
    .position-relative {
        overflow: visible !important;
        z-index: 1000 !important;
        position: relative !important;
    }
    
    .position-absolute.bottom-0.end-0 {
        position: absolute !important;
        right: 0.5rem !important;
        bottom: 0.5rem !important;
        z-index: 1001 !important;
        overflow: visible !important;  /* Importante para que el dropdown no se corte */
    }
    
    /* Asegurar que el dropdown bootstrap funcione - Usar :deep() para scoped */
    :deep(.dropdown) {
        position: relative !important;
    }
    
    /* Mostrar dropdown cuando está activo - Usar :deep() para scoped */
    :deep(.dropdown.show .dropdown-menu),
    :deep(.dropdown-menu.show) {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        animation: none !important;
    }
    
    /* Bootstrap Vue específico */
    :deep(.b-dropdown.show .dropdown-menu) {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
    }
    
    /* Mantener la transformación para dropdown-actions incluso cuando está activo */
    .dropdown-actions :deep(.dropdown.show .dropdown-menu),
    .dropdown-actions :deep(.b-dropdown.show .dropdown-menu),
    .dropdown-actions :deep(.dropdown-menu.show) {
        right: 0 !important;
        left: auto !important;
        transform: translateX(-80%) !important;  /* Mismo valor que arriba */
    }
    
    /* Comportamiento normal del dropdown */
    :deep(.dropdown-menu) {
        display: none;  /* Oculto por defecto */
    }
    
    .btn-link {
        border: none !important;
        background: transparent !important;
        color: #4a5568 !important;
    }
    
    /* Configuración base del dropdown menu */
    :deep(.dropdown-menu) {
        transition: opacity 0.2s ease, visibility 0.2s ease !important;
    }
    
    /* Estilos para los items del dropdown - Usar :deep() */
    :deep(.dropdown-item) {
        padding: 0.75rem 1rem !important;
        white-space: nowrap !important;
        overflow: visible !important;
        color: #495057 !important;
        font-size: 0.9rem !important;
        border: none !important;
        background: transparent !important;
        transition: all 0.2s ease !important;
    }
    
    :deep(.dropdown-item:hover) {
        background-color: #f8f9fa !important;
        color: #2d3748 !important;
        transform: translateX(2px) !important;
    }
    
    /* Reducir espacio entre texto e imágenes */
    .contenedor-info p {
        margin-bottom: 0.5rem !important;  /* Reducir margen entre párrafos */
        padding: 0 !important;
        font-size: 0.9rem !important;  /* Texto ligeramente más pequeño */
        line-height: 1.3 !important;   /* Interlineado más compacto */
    }
    
    /* Optimizar columnas de texto */
    .col-3 {
        padding: 0.25rem !important;  /* Padding reducido */
    }
    
    /* Iconos más compactos */
    .b-icon {
        margin-bottom: 0.25rem !important;
    }
    
    /* Avatares más compactos */
    .ant-avatar {
        margin-bottom: 0.5rem !important;
    }
    
    /* Responsividad mejorada para prevenir overflow */
    @media (max-width: 1200px) {
        .col-1 img {
            width: 100px !important;
        }
        
        .col-5 img {
            max-width: 250px !important;
        }
        
        /* Ajustar columnas en pantallas medianas */
        .row.titulos-form > div {
            font-size: 0.85rem !important;
        }
    }
    
    @media (max-width: 992px) {
        /* Ajustar distribución en tablets */
        .contenedor-info .row.margen {
            flex: none !important;  /* No expandir automáticamente */
            height: auto !important;
        }
        
        .contenedor-info .row.margen > div {
            margin-bottom: 0.5rem !important;
        }
        
        .col-5 img {
            display: block !important;
            margin: 0 auto !important;
            max-width: 250px !important;
        }
        
        /* Reducir padding en pantallas medianas */
        .contenedor-info {
            padding: 0.5rem !important;
        }
    }
    
    @media (max-width: 768px) {
        .contenedor-info {
            padding: 0.15rem !important;  /* Padding ultra reducido */
        }
        
        .col-1 img {
            width: 70px !important;
        }
        
        .col-5 img {
            max-width: 160px !important;  /* Más compacto en móvil */
        }
        
        /* Header más compacto en móviles */
        .row.titulos-form {
            font-size: 0.7rem !important;  /* Texto más pequeño */
            margin-bottom: 0.15rem !important;
        }
        
        .row.titulos-form > div {
            padding: 0.1rem !important;  /* Padding mínimo */
        }
        
        /* Contenido principal más compacto */
        .contenedor-info .row.margen {
            margin-bottom: 0.15rem !important;
        }
        
        /* Texto más compacto */
        .contenedor-info p {
            font-size: 0.8rem !important;
            margin-bottom: 0.25rem !important;
        }
        
        /* Columnas más compactas */
        .contenedor-info .row > [class*="col-"] {
            padding-left: 0.1rem !important;
            padding-right: 0.1rem !important;
        }
        
        /* Footer más compacto */
        .row.margen.titulos-form.mb-2 {
            padding: 0.5rem !important;
            min-height: 50px !important;
            max-height: 65px !important;
        }
        
        .row.margen.titulos-form.mb-2 .col-12 {
            font-size: 0.8rem !important;
            line-height: 1.3 !important;
        }
        
        /* Dropdown más pequeño en móviles */
        .position-absolute.bottom-0.end-0{
            font-size: 2rem !important;
        }
        
        /* Dropdown responsivo en móviles */
        :deep(.dropdown-menu) {
            min-width: 200px !important;
            max-width: 250px !important;
            font-size: 0.85rem !important;
        }
        
        :deep(.dropdown-item) {
            padding: 0.6rem 0.8rem !important;
            font-size: 0.85rem !important;
        }
    }
    
    @media (max-width: 480px) {
        .col-1 img {
            width: 50px !important;
        }
        
        .col-5 img {
            max-width: 120px !important;
        }
        
        /* Header ultra compacto */
        .row.titulos-form {
            font-size: 0.7rem !important;
            margin-bottom: 0.25rem !important;
        }
        
        .row.titulos-form > div {
            padding: 0.15rem !important;
            line-height: 1.1 !important;
        }
        
        /* Contenido más compacto */
        .contenedor-info .row.margen {
            margin-bottom: 0.25rem !important;
        }
        
        /* Footer ultra compacto */
        .row.margen.titulos-form.mb-2 {
            padding: 0.25rem !important;
            min-height: 40px !important;    /* Altura mínima muy pequeña */
            max-height: 50px !important;    /* Altura máxima muy pequeña */
        }
        
        .row.margen.titulos-form.mb-2 .col-12 {
            font-size: 0.7rem !important;
            line-height: 1.2 !important;
        }
        
        /* Padding mínimo en móviles pequeños */
        .contenedor-info {
            padding: 0.1rem !important;
        }
        
        /* Dropdown ultra compacto en móviles pequeños */
        :deep(.dropdown-menu) {
            min-width: 180px !important;
            max-width: 220px !important;
            font-size: 0.8rem !important;
        }
        
        :deep(.dropdown-item) {
            padding: 0.5rem 0.7rem !important;
            font-size: 0.8rem !important;
        }
        
        .position-absolute.bottom-0.end-0{
            font-size: 1.8rem !important;
        }
    }
    
    /* Estilos para el modal de novedades */
    .modal-dialog {
        max-width: 90vw !important;
        margin: 2rem auto !important;
    }
    
    .modal-content {
        border: none !important;
        border-radius: 12px !important;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
        overflow: hidden !important;
    }
    
    .modal-header {
        background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
        color: white !important;
        border-bottom: none !important;
        padding: 1.5rem 2rem !important;
        position: relative !important;
    }
    
    .modal-title {
        font-size: 1.25rem !important;
        font-weight: 600 !important;
        margin: 0 !important;
    }
    
    .btn-close {
        background: rgba(255, 255, 255, 0.3) !important;
        border-radius: 50% !important;
        opacity: 0.8 !important;
        width: 32px !important;
        height: 32px !important;
    }
    
    .btn-close:hover {
        opacity: 1 !important;
        background: rgba(255, 255, 255, 0.5) !important;
    }
    
    .modal-body {
        padding: 2rem !important;
        background-color: #f8fafc !important;
    }
    
    /* Botón Limpiar Novedades */
    .btn-primary.my-3 {
        background: linear-gradient(135deg, #4a5568, #2d3748) !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 0.75rem 1.5rem !important;
        font-weight: 600 !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 4px 14px 0 rgba(74, 85, 104, 0.3) !important;
    }
    
    .btn-primary.my-3:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 20px 0 rgba(74, 85, 104, 0.4) !important;
        background: linear-gradient(135deg, #2d3748, #1a202c) !important;
    }
    
    /* Tabla de novedades mejorada */
    .table-responsive {
        border-radius: 12px !important;
        overflow: hidden !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
        background: white !important;
    }
    
    .table {
        margin-bottom: 0 !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }
    
    .table thead th {
        background: linear-gradient(135deg, #1f2937, #374151) !important;
        color: white !important;
        font-weight: 600 !important;
        text-transform: uppercase !important;
        font-size: 0.875rem !important;
        letter-spacing: 0.05em !important;
        padding: 1rem 1.5rem !important;
        border: none !important;
        position: relative !important;
    }
    
    .table thead th:first-child {
        border-top-left-radius: 12px !important;
    }
    
    .table thead th:last-child {
        border-top-right-radius: 12px !important;
    }
    
    .table tbody tr {
        background-color: white !important;
        transition: all 0.2s ease !important;
    }
    
    .table tbody tr:nth-child(even) {
        background-color: #f8fafc !important;
    }
    
    .table tbody tr:hover {
        background-color: #e0f2fe !important;
        transform: scale(1.01) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    }
    
    .table tbody td {
        padding: 1rem 1.5rem !important;
        border: none !important;
        border-bottom: 1px solid #e5e7eb !important;
        color: #374151 !important;
        font-size: 0.9rem !important;
        line-height: 1.5 !important;
        vertical-align: middle !important;
    }
    
    /* Primera columna (Item) destacada */
    .table tbody td:first-child {
        background: linear-gradient(135deg, #eff6ff, #dbeafe) !important;
        font-weight: 600 !important;
        color: #1e40af !important;
        text-align: center !important;
        width: 60px !important;
    }
    
    /* Última fila sin border-bottom */
    .table tbody tr:last-child td {
        border-bottom: none !important;
    }
    
    /* Responsive de la tabla */
    @media (max-width: 768px) {
        .modal-dialog {
            max-width: 95vw !important;
            margin: 1rem auto !important;
        }
        
        .modal-header,
        .modal-body {
            padding: 1rem !important;
        }
        
        .table thead th,
        .table tbody td {
            padding: 0.75rem 0.5rem !important;
            font-size: 0.8rem !important;
        }
        
        .table thead th {
            font-size: 0.75rem !important;
        }
    }
    
    @media (max-width: 480px) {
        .table thead th,
        .table tbody td {
            padding: 0.5rem 0.25rem !important;
            font-size: 0.75rem !important;
        }
        
        .modal-title {
            font-size: 1.1rem !important;
        }
    }
    
    /* Contenedor principal del modal novedades */
    .novedades-container {
        padding: 0 !important;
    }
    
    /* Información del CBI */
    .novedades-info h6 {
        margin-bottom: 0.5rem !important;
        font-size: 1rem !important;
    }
    
    .novedades-info .badge {
        font-size: 0.875rem !important;
        padding: 0.25rem 0.5rem !important;
    }
    
    /* Botón con gradiente */
    .btn-gradient-primary {
        background: linear-gradient(135deg, #4a5568, #2d3748) !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 0.75rem 1.5rem !important;
        font-weight: 600 !important;
        color: white !important;
        transition: all 0.3s ease !important;
        box-shadow: 0 4px 14px 0 rgba(74, 85, 104, 0.3) !important;
    }
    
    .btn-gradient-primary:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 20px 0 rgba(74, 85, 104, 0.4) !important;
        background: linear-gradient(135deg, #2d3748, #1a202c) !important;
        color: white !important;
    }
    
    /* Badge para tipo de intervención */
    .badge.bg-info {
        background-color: #0dcaf0 !important;
        color: #000 !important;
        font-weight: 500 !important;
        padding: 0.375rem 0.75rem !important;
        border-radius: 6px !important;
    }
    
    /* Celda de observaciones con límite de texto */
    .observaciones-cell {
        max-width: 200px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        position: relative !important;
    }
    
    .observaciones-cell:hover {
        white-space: normal !important;
        overflow: visible !important;
        background-color: #f0f9ff !important;
        z-index: 10 !important;
        position: relative !important;
    }
    
    /* Estado vacío */
    .empty-state {
        padding: 3rem 2rem !important;
        text-align: center !important;
    }
    
    .empty-state .text-success {
        color: #059669 !important;
    }
    
    /* Iconos en headers */
    .table thead th .b-icon {
        margin-right: 0.5rem !important;
        color: #e5e7eb !important;
    }
    
    /* Columna de acciones */
    .table tbody td:last-child {
        text-align: center !important;
        width: 80px !important;
        padding: 0.75rem 0.5rem !important;
    }
    
    /* Botón eliminar */
    .btn-danger.btn-sm {
        padding: 0.375rem 0.5rem !important;
        border-radius: 6px !important;
        font-size: 0.8rem !important;
        transition: all 0.2s ease !important;
        border: none !important;
        background: linear-gradient(135deg, #dc2626, #b91c1c) !important;
        box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3) !important;
    }
    
    .btn-danger.btn-sm:hover:not(:disabled) {
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 8px rgba(220, 38, 38, 0.4) !important;
        background: linear-gradient(135deg, #b91c1c, #991b1b) !important;
    }
    
    .btn-danger.btn-sm:disabled {
        opacity: 0.6 !important;
        cursor: not-allowed !important;
        transform: none !important;
        box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2) !important;
    }
    
    /* Mejoras responsive para el modal */
    @media (max-width: 768px) {
        .novedades-container {
            padding: 0 !important;
        }
        
        .d-flex.justify-content-between {
            flex-direction: column !important;
            gap: 1rem !important;
        }
        
        .novedades-info {
            text-align: center !important;
        }
        
        .btn-gradient-primary {
            width: 100% !important;
            padding: 0.875rem 1rem !important;
        }
        
        .observaciones-cell {
            max-width: 120px !important;
        }
        
        .empty-state {
            padding: 2rem 1rem !important;
        }
        
        .table thead th .b-icon {
            display: none !important;  /* Ocultar iconos en móvil para ahorrar espacio */
        }
        
        /* Botón eliminar más pequeño en móvil */
        .btn-danger.btn-sm {
            padding: 0.25rem 0.375rem !important;
            font-size: 0.75rem !important;
        }
        
        .table tbody td:last-child {
            width: 60px !important;
            padding: 0.5rem 0.25rem !important;
        }
    }
    
    @media (max-width: 480px) {
        .observaciones-cell {
            max-width: 80px !important;
            font-size: 0.75rem !important;
        }
        
        .badge.bg-info {
            padding: 0.25rem 0.5rem !important;
            font-size: 0.75rem !important;
        }
        
        .empty-state h5 {
            font-size: 1rem !important;
        }
        
        .empty-state p {
            font-size: 0.875rem !important;
        }
        
        /* Botón eliminar ultra compacto */
        .btn-danger.btn-sm {
            padding: 0.2rem 0.3rem !important;
            font-size: 0.7rem !important;
        }
        
        .table tbody td:last-child {
            width: 50px !important;
            padding: 0.375rem 0.15rem !important;
        }
    }
</style>